import { ReactElement, ReactNode } from 'react';

import useFeature from '~/store/clinic/hooks/useFeature';
import useRole from '~/store/user/hooks/useRole';
import { SignalRCrisisContext } from '~/ui/hooks/useCrisisSignalR';
import { useSignalRToken } from './SignalRTokenProvider';

interface IProps {
  children: ReactNode | ReactNode[];
}

const CrisisRequestsProvider = ({ children }: IProps): ReactElement => {
  const { token, isOnline, handleError, handleConnection } = useSignalRToken();
  const { isLocalAdmin } = useRole();
  const { isCrisisAvailable, isCrisisAlertsAvailable } = useFeature();

  const isConnectionEnabled = Boolean(isLocalAdmin) && isCrisisAvailable && isCrisisAlertsAvailable;

  const isConnected = !!token && isConnectionEnabled && isOnline;

  const connectionCloseDelay = () =>
    new Promise<void>(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });

  return (
    <SignalRCrisisContext.Provider
      connectEnabled={isConnected}
      withCredentials={false}
      dependencies={[token]}
      transport={2}
      url={process.env.REACT_APP_API_URL.replace(
        'api/v1/',
        `hubs/crisis-queue?access_token=${token}`,
      )}
      logger={6}
      onBeforeClose={connectionCloseDelay}
      onOpen={handleConnection}
      onReconnect={handleConnection}
      onError={handleError}
    >
      {children}
    </SignalRCrisisContext.Provider>
  );
};

export default CrisisRequestsProvider;
